module.exports = __webpack_public_path__ + "img/pango-network-logo.e4783c7e.png";